import React from "react";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import NotificationBell from "./Sms";

const Home = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <NotificationBell />
            </FeedLayout>
        </MainLayout>
    );
};

export default Home;
